import React from 'react'
import { Switch, Redirect } from 'react-router-dom'
import Layout from './Layout'
import PrivateRoutes from './PrivateRoutes'
import * as Page from '../Container/Auth'
import RouteFunction from './RouteFunction'
export default function Index() {

    return (
        <Switch>
            {RouteFunction(Page, 'authRoute')}
            <PrivateRoutes path="/" component={Layout}/>
            {/* <PrivateRoutes path="/crm" component={CrmList} /> */}
            <Redirect to='/dashboard' from="*" />
        </Switch>
    )
}